export default {
	addTweets: '/tweets', //新增推文
	getTweetsList: '/tweets/list', // 推文列表
	getTweetsDetail: '/tweets/', //查看详情
	editTweets: '/tweets/', //编辑
	retryTweets: '/tweets/{id}/send', //重试
	getCount: '/tweets/count',
	removeTwitter: '/tweets/{id}', //删除推文
	modifyTwitter: '/tweets/{id}/send_date_time', //修改推送日期时间
	getTweetsShare: '/tweets/share/{id}', //帖子详情
	getCommentList: '/tweets/share/{id}/comments/list', //帖子评论列表
	twitterComment: '/tweets/share/{id}/comments', //帖子评论回复
	articleTranslate: '/tweets/translate', //百度翻译
	tiktokInteractionSettings: '/admin/pages/tiktok-interaction-settings', // tiktok互动设置
	tiktokPrivacyLevels: '/admin/pages/tiktok-privacy-levels', // tiktok隐私级别
};
